import { render, staticRenderFns } from "./aiUser.vue?vue&type=template&id=0060e07e&scoped=true&"
import script from "./aiUser.vue?vue&type=script&lang=js&"
export * from "./aiUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060e07e",
  null
  
)

export default component.exports